const currencyCodes = ['ALL', 'DZD', 'ARS', 'AMD', 'AUD', 'BSD', 'BHD', 'BYN', 'BMD', 'BOB', 'BAM',
    'BWP', 'BRL', 'GBP', 'BND', 'BGN', 'CAD', 'CVE', 'XAF', 'XOF', 'CLP', 'CNY', 'COP', 'CRC', 'HRK',
    'CZK', 'DKK', 'XCD', 'EGP', 'EUR', 'FJD', 'XPF', 'GEL', 'GHS', 'GTQ', 'HKD', 'HUF', 'ISK', 'INR',
    'IDR', 'ILS', 'JPY', 'JOD', 'KZT', 'KES', 'KWD', 'AOA', 'KGS', 'LVL', 'LBP', 'LSL', 'LTL', 'MOP',
    'MKD', 'MGA', 'MYR', 'MVR', 'MUR', 'MZN', 'MXN', 'MDL', 'MAD', 'NAD', 'ANG', 'RON', 'AZN', 'NZD',
    'NGN', 'NOK', 'OMR', 'PKR', 'PAB', 'PGK', 'PYG', 'PEN', 'PHP', 'PLN', 'QAR', 'RUB', 'SAR', 'RSD',
    'SCR', 'SGD', 'ZAR', 'KRW', 'LKR', 'SZL', 'SEK', 'CHF', 'TWD', 'TZS', 'THB', 'TOP', 'TTD', 'TND',
    'TRY', 'UAH', 'AED', 'USD', 'UZS', 'VUV', 'VND'];

export {
    // eslint-disable-next-line import/prefer-default-export
    currencyCodes
};
